import { Checkbox, Label } from "@components";
import { useState } from "react";

export const BenefitEnvironment = ({ benefit, brands, onChange }) => {
  const [brandsSelected, setBrands] = useState([]);

  const verifyCheck = (brandId) => {
    if (benefit?.brands_valid?.includes(brandId)) {
      return true;
    }
    return false;
  };

  const addBrand = (brand) => {
    setBrands((prevBrands) => {
      let newBrands;
      if (benefit?.brands_valid?.includes(brand)) {
        newBrands = benefit.brands_valid.filter(
          (item) => item !== brand
        );
      } else {
        newBrands = [...(benefit?.brands_valid || []), brand];
      }
      onChange({ ...benefit, brands_valid: newBrands });
      return newBrands;
    });
  };

  return (
    <>
      <Label
        text={"Onde o benefício poderá ser utilizado?"}
        className={"mb-20"}
      />
      {(brands || []).map((item) => {
        return (
          <Checkbox
            key={item.id}
            family="place"
            className="mb-10"
            value={item.id}
            checked={verifyCheck(item.id)}
            onChange={() => addBrand(item.id)}
          >
            {item.name}{" "}
          </Checkbox>
        );
      })}
    </>
  );
};
